export default __webpack_public_path__ + "static/media/Snd_A_Starts.df40d0f6.mp3";